module.exports = __webpack_public_path__ + "static/media/wedding81.1c756003.png";